<template>
  <v-sheet style="background-color:#fff;height:100%">
    <v-toolbar floating elevation="0" style="border-bottom:1px solid #ddd" pb-5>
      <v-btn :to="{ name: 'invoices' }" icon text dark>
        <v-icon color="black">arrow_back</v-icon>
      </v-btn>

        <v-toolbar-title class="text-uppercase">
            Recibo #{{ invoice_id }}
        </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-toolbar-title class="text-uppercase">
            Valor total: {{ formatarDinheiro(invoice.credit.credit_value) }}
            | <u> {{$creditStatus[invoice.credit.status].s}} </u>
        </v-toolbar-title>
      
    </v-toolbar>

    <v-container fluid>

      <v-layout>
        <v-flex sm-12>
            <v-flex></v-flex><!--Imagem-->
            <v-flex>

              <v-flex>
              
              </v-flex>

              <v-flex>

              </v-flex>


            </v-flex>

        </v-flex>
      </v-layout>
      
      <v-data-table
        :headers="headers"
        :items="registros"
        multi-sort
        :items-per-page="200"
        class="elevation-0 mt-3"
        fixed-header
      >
        <template v-slot:item.i_date="{item}">
            {{String(item.i_date).substr(4,2)+"/"+String(item.i_date).substr(0,4)}}
        </template>
      </v-data-table>
    </v-container>
  </v-sheet>
</template>
<script>
import PaymentService from "../../../app/Rest/payment";
var paymentService = null;
import { money } from "../../../app/general";
var _money = new money();

export default {
  data: () => ({
    invoice_id: null,
    invoice : null,
    registros: [],
    headers: [
       { text: "Periodo", align: "left", sortable: true, value: "i_date" },
        { text: "Parceiro", align: "left", sortable: true, value: "s_partner" },
        { text: "Serviço", value: "s_partner_company" },
        { text: "Faixa/Vídeo", value: "pct_track_name" },
        { text: "Produto", value: "pct_product_name" },
        { text: "ISRC", value: "s_isrc" },
        { text: "UPC", value: "s_upc" },
        { text: "Quantidade Plays/Views", value: "i_qtd" },
        { text: "Valor", value: "t_val_partner_final" }
    ],
  }),
  computed: {},
  created() {
    this.invoice_id = this.$route.params.invoice_id;
    paymentService = PaymentService.build();
    this.load_credit_data();
  },
  mounted() {},
  methods: {
    load_credit_data() {
      paymentService
        .get_invoice(this.invoice_id)
        .then((e) => {
          this.invoice = e.items.invoice;
          this.registros = e.items.invoice.detailed;
        })
        .finally(() => {
          this.load_feito = true;
          this.$store.commit("loading", false);
        });
    },
    formatarDinheiro(valor, moeda="R$", casas=2) {
            let t = valor;
            _money.set_currency(moeda)
            return _money.formatWithCurrency(t, casas, ",");
        }

  },
};
</script>
